import { configureStore } from "@reduxjs/toolkit";
import { authApi } from "./features/auth/authApi";
import { paymentApi } from "./features/payments/paymentApi";
import { userApi } from "./features/user/userApi";
import { withdrawalApi } from "./features/withdrawalApi/withdrawalApi";
import { adminApi } from "./features/admin/adminApi";
import { dashboardApi } from "./features/dashboard/dashboardApi";
import { blockApi } from "./features/block/blockApi";

const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [withdrawalApi.reducerPath]: withdrawalApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [blockApi.reducerPath]: blockApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authApi.middleware)
      .concat(paymentApi.middleware)
      .concat(userApi.middleware)
      .concat(withdrawalApi.middleware)
      .concat(adminApi.middleware)
      .concat(dashboardApi.middleware)
      .concat(blockApi.middleware)
});

export default store;